import React, { createContext, useContext, useState, useEffect } from "react";

interface CursorContextType {
  position: { x: number; y: number };
  cursorSize: number;
  isHover: boolean;
  setPosition: (pos: { x: number; y: number }) => void;
  setCursorSize: (size: number) => void;
  setHover: (hover: boolean) => void;
}

const CursorContext = createContext<CursorContextType | undefined>(undefined);

export const CursorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [cursorSize, setCursorSize] = useState(24);
  const [isHover, setHover] = useState(false);

  // Track the mouse position globally
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <CursorContext.Provider
      value={{
        position,
        cursorSize,
        isHover,
        setPosition,
        setCursorSize,
        setHover,
      }}
    >
      {children}
    </CursorContext.Provider>
  );
};

export const useCursor = () => {
  const context = useContext(CursorContext);
  if (!context) {
    throw new Error("useCursor must be used within a CursorProvider");
  }
  return context;
};
